module.exports = {"prices":{"location":"LPL","per_day":"10.87","per_week":"86.99","two_week":"138.99","off_airport":"92.99","on_airport":"86.99","meet_and_greet":"105.99","per_day_off_airport":"11.62","per_day_on_airport":"10.87","per_day_meet_and_greet":"13.25","startDate":"25-08-2025","endDate":"01-09-2025","dateUsed":"25-06-2025"}}


//////////////////
// WEBPACK FOOTER
// ./config/exports/prices/parking/LPL.json
// module id = 142
// module chunks = 119